import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.clickHandler = this.toggle.bind(this)
    this.element.addEventListener("click", this.clickHandler)
  }

  disconnect() {
    this.element.removeEventListener("click", this.clickHandler)
  }

  toggle(event) {
    const toggleElem = event.target.closest(".toggle-visible, .toggle-apparent")
    if (!toggleElem) return

    const { id } = toggleElem.dataset
    if (!id) return

    const children = this.element.querySelectorAll(`.children_${id}`)
    children.forEach(card => card.classList.toggle("hidden"))
    toggleElem.classList.toggle("closed")

    if (children.length > 0) {
      this.saveStateToServer(children[0])
    }

    this.dispatchGlobalUpdate()
  }

  toggleAll(event) {
    const shouldCollapse = !event.target.checked

    const allToggles = this.element.querySelectorAll(".toggle-visible, .toggle-apparent")

    allToggles.forEach(toggleElem => {
      const { id } = toggleElem.dataset
      if (!id) return

      const children = this.element.querySelectorAll(`.children_${id}`)
      if (children.length === 0) return

      const isAlreadyInTargetState = children[0].classList.contains("hidden") === shouldCollapse

      if (!isAlreadyInTargetState) {
        children.forEach(card => card.classList.toggle("hidden", shouldCollapse))
        toggleElem.classList.toggle("closed", shouldCollapse)

        this.saveStateToServer(children[0])
      }
    })
  }

  async forceState(shouldCollapse) {
    const toggleElem = this.element.querySelector(".toggle-visible, .toggle-apparent")
    if (!toggleElem) return

    const { id } = toggleElem.dataset
    if (!id) return

    const children = this.element.querySelectorAll(`.children_${id}`)
    if (children.length === 0) return

    const isCurrentlyHidden = children[0].classList.contains("hidden")
    if (isCurrentlyHidden === shouldCollapse) return

    children.forEach(card => card.classList.toggle("hidden", shouldCollapse))
    toggleElem.classList.toggle("closed", shouldCollapse)

    await this.saveStateToServer(children[0])

    this.dispatchGlobalUpdate()
  }

  saveStateToServer(elem) {
    if (!this.hasUrlValue || !elem) return Promise.resolve()

    const isHidden = elem.classList.contains("hidden")
    const boardClass = Array.from(elem.classList).find(c => c.startsWith("children_"))
    const boardType = boardClass ? boardClass.replace("children_board_", "") : this.element.dataset.id
    const state = "all"

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    return fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken || ""
      },
      body: JSON.stringify({
        board_type: boardType,
        state: state,
        collapsed: isHidden
      })
    })
      .then(response => {
        if (!response.ok) console.error(`Ошибка сохранения доски ${boardType}`)
      })
      .catch(error => console.error("Ошибка сети при сохранении:", error))
  }


  isCollapsed() {
    const firstChild = this.element.querySelector("[class*='children_']")
    return firstChild ? firstChild.classList.contains("hidden") : false
  }

  _updateGlobalCheckboxState() {
    if (!this.hasModeToggleTarget) return

    const allChildren = this.element.querySelectorAll("[class*='children_entry_'], .children_empty_swimlane")
    if (allChildren.length === 0) return

    const hasHidden = Array.from(allChildren).some(card => card.classList.contains("hidden"))

    this.modeToggleTarget.checked = !hasHidden
  }

  dispatchGlobalUpdate() {
    const globalManagerElem = document.querySelector("[data-controller~='kanban-global']")
    if (globalManagerElem) {
      const manager = this.application.getControllerForElementAndIdentifier(globalManagerElem, "kanban-global")
      if (manager) manager.updateCheckboxState()
    }
  }

}
